export interface ReverseGeocodeResult {
  display_name: string;
  address: {
    state: string;
    district?: string;
    postcode: string;
  };
}

export const reverseGeocode = async (
  lat: number,
  lon: number
): Promise<ReverseGeocodeResult | null> => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18&addressdetails=1`
    );

    if (!response.ok) {
      throw new Error(`Geocoding failed: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Reverse geocoding error:", error);
    return null;
  }
};

// Utility function to delay requests to respect Nominatim's usage policy
export const delay = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));
